// 柱形图
import ChartTemplate from '../ChartTemplate';

export default {
  extends: ChartTemplate,
  methods: {
    initParamAfter () {
      if (this.paramFormData.xMiddleLine) {
        let rows = this.dataSource.slice(1).sort((a, b) => a[0] - b[0]);
        let middleValue = parseInt((rows[rows.length - 1][0] - rows[0][0]) / 2);
        let option = { "xAxis": { "plotLines": [{ "value": middleValue, "color": "black", "dashStyle": "dot", "width": 2 }] } }
        this.paramFormData.xMiddleLine = option;
      }
    },
    initChartAfter () {
      this.fixXLabels();
    },
    fixXLabels () {
      let xAxisLabels = this.chart.container.getElementsByClassName('highcharts-xaxis-labels');
      if (xAxisLabels) {
        let g = xAxisLabels[0];
        if (g) {
          let gbbox = g.getBBox();
          if (gbbox.x < 5) {
            let option = { xAxis: { labels: { autoRotation: [-90] } } }
            this.chart.update(option);
          }
        }
      }
    }
  }
}